app.component("invoiceItem", {
	templateUrl: "app/src/js/components/invoice/invoice.html",
	controller: "invoiceItemController",
	bindings: {
        invoice: "=",
        billingItems: "=",
    },
});

app.controller("invoiceItemController", [
	"$scope",
	function ($scope) {
        this.$onInit = function () {
            $scope.selectedInvoice = $scope.$ctrl.invoice;
        }

        $scope.getTaxRate = function (item_code) {
            if (!$scope.$ctrl.billingItems || $scope.$ctrl.billingItems.length === 0) {
                return '';
            }

            const item = $scope.$ctrl.billingItems.find(t => t.code === item_code);
            return item ? `Tax rate: ${item.tax_rate}% GST on Income` : '';
        };

        $scope.calculateDiscount = function () {
            if (!$scope.selectedInvoice || !$scope.selectedInvoice.line_items) {
                return 0;
            }

            return $scope.selectedInvoice.line_items.reduce((acc, current) => {
                const discount = current.discount_rate || 0;
                const price = current.unit_amount || 0;
                const qty = current.quantity || 0;

                return acc + (discount * price * qty * 0.01);
            }, 0);
        };
        
	},
]);